export const SET_LIMIT = "SET_LIMIT";
export const SET_SORT_BY = "SET_SORT_BY";

export const setLimit = (limit: number) => ({
  type: SET_LIMIT,
  payload: limit,
});

export const setSortBy = (sortBy: string) => ({
  type: SET_SORT_BY,
  payload: sortBy,
});
